import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import dayjs from 'dayjs'
const db = firebase.firestore()

const state = {
  contacts: [],
  contact: null
}

const actions = {
  GET_CONTACT ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('contacts')
        .doc(payload.id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            commit('SET_CONTACT', doc.data())
            resolve(doc)
          }
        })
        .catch(reject)
    })
  },
  GET_CONTACTS ({ commit }) {
    return new Promise((resolve, reject) => {
      db.collection('contacts').get().then((snapshot) => {
        let contacts = []
        snapshot.forEach((doc) => {
          contacts.push(doc.data())
        })
        commit('SET_CONTACTS', contacts)
        resolve(contacts)
      }).catch(reject)
    })
  },
  CREATE_CONTACT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload.contact
      db.collection('contacts')
        .add(data)
        .then(snapshot => {
          data.id = snapshot.id
          db.collection('contacts')
            .doc(snapshot.id)
            .update(data)
            .then(snapshot => {
              resolve(snapshot)
            })
            .catch(reject)
        })
        .catch(reject)
    })
  },
  UPDATE_CONTACT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload
      db.collection('contacts')
        .doc(data.id)
        .update({
          firstName: data.firstName,
          lastName: data.lastName,
          createdAt: data.createdAt,
          isActive: data.isActive,
          paid: data.paid,
          description: data.description,
          shortDescription: data.shortDescription,
          type: data.type,
          endorsingBody: data.endorsingBody,
          updatedAt: dayjs().format(),
          availableTo: data.availableTo,
          picture: data.picture
        })
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  }
}

const getters = {
}

const mutations = {
  SET_CONTACTS (state, payload) {
    state.contacts = payload
  },
  SET_CONTACT (state, payload) {
    state.contact = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
